import * as React from "react";
import { IconBallFootball } from "@tabler/icons-react";
import { IconChevronLeft, IconChevronRight, IconRoulette } from "../components/icons.jsx";
import "./MiniGamesPage.css";

/** @param {{ onBack: () => void, onOpenVaBank: () => void, onOpenPenalty: () => void }} props */
export function MiniGamesPage({ onBack, onOpenVaBank, onOpenPenalty }) {
  const backButton = window.Telegram?.WebApp?.BackButton;
  React.useEffect(() => {
    if (!backButton) return;
    backButton.show();
    backButton.onClick(onBack);
    return () => {
      backButton.offClick(onBack);
      backButton.hide();
    };
  }, [backButton, onBack]);

  return (
    <section className="mini-games-page" aria-labelledby="mini-games-title">
      <header className="mini-games-header">
        <button type="button" className="mc-icon-button mc-page-back" onClick={onBack} aria-label="Назад на главную">
          <IconChevronLeft aria-hidden="true" />
        </button>
        <h1 id="mini-games-title">Мини-игры</h1>
      </header>
      <button type="button" className="mini-games-tile" onClick={onOpenVaBank}>
        <IconRoulette aria-hidden="true" />
        <b>Ва-банк</b>
        <IconChevronRight aria-hidden="true" />
      </button>
      <button type="button" className="mini-games-tile mini-games-tile-penalty" onClick={onOpenPenalty}>
        <IconBallFootball aria-hidden="true" />
        <b>Пенальти</b>
        <IconChevronRight aria-hidden="true" />
      </button>
    </section>
  );
}
